import React from 'react';
import { motion } from 'framer-motion';

export default function DMCA() {
  return (
    <div className="min-h-screen py-20 px-4">
      <div className="max-w-4xl mx-auto space-y-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">DMCA Policy</h1>
          <p className="text-xl text-white/70">Last updated: January 29, 2025</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="space-y-8"
        >
          {sections.map((section, index) => (
            <div key={index} className="glass p-8 rounded-modern space-y-4">
              <h2 className="text-2xl font-semibold text-white">{section.title}</h2>
              <div className="text-white/80 space-y-4">
                {section.content}
              </div>
            </div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="glass p-8 rounded-modern mt-12"
        >
          <h2 className="text-2xl font-semibold text-white mb-4">Contact Our DMCA Agent</h2>
          <p className="text-white/80">
            For DMCA notices and counter-notices, please contact our designated agent at:{' '}
            <a
              href="mailto:dmca@remuvr.com"
              className="text-blue-400 hover:text-blue-300 transition-colors"
            >
              dmca@remuvr.com
            </a>
          </p>
        </motion.div>
      </div>
    </div>
  );
}

const sections = [
  {
    title: "DMCA Compliance",
    content: (
      <>
        <p>
          Remuvr respects intellectual property rights and expects its users to do the same.
          We comply with the Digital Millennium Copyright Act (DMCA) and respond promptly to
          notices of alleged copyright infringement.
        </p>
      </>
    )
  },
  {
    title: "Filing a DMCA Notice",
    content: (
      <>
        <p>Your DMCA notice must include:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Physical or electronic signature of the copyright owner</li>
          <li>Description of the copyrighted work claimed to be infringed</li>
          <li>Description of where the infringing material is located on our service</li>
          <li>Your contact information</li>
          <li>Statement of good faith belief in infringement</li>
          <li>Statement of accuracy under penalty of perjury</li>
        </ul>
      </>
    )
  },
  {
    title: "Counter-Notice Procedure",
    content: (
      <>
        <p>If you believe your content was wrongly removed, you may file a counter-notice including:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Your physical or electronic signature</li>
          <li>Identification of removed content and its original location</li>
          <li>Statement under penalty of perjury of good faith belief in wrongful removal</li>
          <li>Your name, address, and phone number</li>
          <li>Consent to local federal court jurisdiction</li>
        </ul>
      </>
    )
  },
  {
    title: "Repeat Infringers",
    content: (
      <>
        <p>
          We maintain a policy of terminating accounts of users who are repeat infringers of
          copyright. A repeat infringer is a user who has been notified of infringing
          activity multiple times or has had content removed more than twice.
        </p>
      </>
    )
  }
];
